// extracted by mini-css-extract-plugin
module.exports = {"DirectedText":"styles_DirectedText__qavPm","RTL":"styles_RTL__rwgOH"};